import React from "react"
import {connect} from "react-redux"
import {createStructuredSelector} from "reselect"
import styled from "styled-components"
import {Firebase} from "../../../components/Firebase"
import {Report as ReportComponent} from "../components/Report"
import {makeMomentDate} from "../helpers/makeMomentDate"
import {makeReportValue} from "../helpers/makeReportValue"
import {getCalculationInputMapper} from "../modules/calculation/input"
import {getCalculationOutputMapper} from "../modules/calculation/output"
import {
  getCountries,
  getFilingStatusTypes,
  getJurisdictionsPayload,
} from "../modules/jurisdictions"
import {getReportSummaryTemplate} from "../modules/report/templates"

class ReportContainerUnconnected extends React.Component {
  componentDidMount() {
    this.firebase = new Firebase()
  }

  _makeInput = () =>
    this.props.mapInputToTemplate(this.props.template, {
      countries: this.props.countries,
      filingStatuses: this.props.filingStatuses,
      jurisdictions: this.props.jurisdictions,
    })

  _makeOutput = () => this.props.mapOutputToTemplate(this.props.template)

  render() {
    const input = this._makeInput()
    const output = this._makeOutput()

    return (
      <OuterDiv>
        <ReportComponent
          assigneeId={input.assigneeId}
          assigneeName={`${input.firstName} ${input.lastName}`}
          badges={output.badges}
          columns={output.columns}
          demographics={input.demographics}
          endDate={input.endDate}
          endLocation={input.endLocation}
          organization={input.organization}
          renderDate={(date) =>
            makeMomentDate(date, this.props.template.dateFormat)
          }
          renderValue={makeReportValue}
          startDate={input.startDate}
          startLocation={input.startLocation}
          tables={output.tables}
        />
      </OuterDiv>
    )
  }
}

const OuterDiv = styled.div`
  margin-bottom: ${(props) => props.theme.gutter / 2}px;
`

const createSelectors = createStructuredSelector({
  countries: getCountries,
  filingStatuses: getFilingStatusTypes,
  jurisdictions: getJurisdictionsPayload,
  mapInputToTemplate: getCalculationInputMapper,
  mapOutputToTemplate: getCalculationOutputMapper,
  template: getReportSummaryTemplate,
})

export const ReportContainer = connect(createSelectors, {})(ReportContainerUnconnected)
